

import { Injectable } from '@angular/core';


@Injectable({
    providedIn: 'root'
})
export class NotificationService {
    //TODO: Remove this service
    constructor() { }

    success(message: string) {
        // this.snackBar.success(message);
    }

    openSnackBar(message: string, action: string) {
        // this.snackBar.open(message, action, {
        //     duration: 2000,
        // });
    }
    openSnackBarr(msg, action: string) {
        // this.snackBar.open(msg, action, {
        //     duration: 4000,
        // });
    }


}